
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 128 128"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M117.6 26.5c-1.4-1.4-3.6-1.4-4.9 0l-3.7 3.7c-.1-9.2-1.5-20-13.8-24-1.8-.6-3.8.4-4.4 2.2-.6 1.8.4 3.8 2.2 4.4 7.7 2.5 9.1 8.5 9.2 17.3l-3.7-3.7c-1.4-1.4-3.6-1.4-4.9 0-1.4 1.4-1.4 3.6 0 4.9l9.6 9.6c1.3 1.3 3.4 1.5 5 0l9.6-9.6c1.1-1.2 1.1-3.4-.2-4.8z"}}),_c('path',{attrs:{"d":"M115.3 48.1H79.9V12.7c0-7-5.6-12.7-12.6-12.7H12.6C5.6 0 0 5.7 0 12.7v102.7c0 7 5.6 12.7 12.6 12.7h102.8c7 0 12.7-5.6 12.7-12.6V60.7c-.1-6.9-5.8-12.6-12.8-12.6zm-87.2-40h23.7v5.3H28.1V8.1zM12.6 119.9c-2.5 0-4.5-2.1-4.5-4.6V12.7c0-2.5 2-4.6 4.5-4.6h7.5v5.6c0 4.2 3.5 7.7 7.7 7.7h24.4c4.2 0 7.7-3.5 7.7-7.7V8.1h7.5c2.5 0 4.5 2.1 4.5 4.6v102.7c0 2.5-2 4.6-4.5 4.6H12.6zm107.3-20h-5.3V76.2h5.3v23.7zm0-31.7h-5.6c-4.2 0-7.7 3.5-7.7 7.7v24.4c0 4.2 3.5 7.7 7.7 7.7h5.6v7.5c0 2.5-2.1 4.5-4.6 4.5H79c.6-1.4.9-3 .9-4.6V56.2h35.5c2.5 0 4.6 2 4.6 4.5v7.5z"}})])
          )
        }
      }
    